import { render, staticRenderFns } from "./PxLeituraRegistro.vue?vue&type=template&id=cf7174b8"
import script from "./PxLeituraRegistro.vue?vue&type=script&lang=js"
export * from "./PxLeituraRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports